
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { exportInfor, exportOrderInfor } from '@/api/index'
@Component({
  name: 'TitleIndex',
})
export default class extends Vue {
  @Prop() private flag!: any
  @Prop() private tateData!: any
  @Prop() private turnoverData!: any

  nowIndex = 2 - 1
  value = []
  tabsParam = ['昨日', '近7日', '近30日', '本周', '本月']
  @Watch('flag')
  getNowIndex(val) {
    this.nowIndex = val
  }

  get currentStoreId(): string {
    return UserModule.storeId || ''
  }

  // tab切换
  toggleTabs(index: number) {
    this.nowIndex = index
    this.value = []
    this.$emit('sendTitleInd', index + 1)
  }

  private async downloadBlob(res: any, filename: string) {
    const blob = res.data
    if (blob && blob.type && blob.type.indexOf('application/json') !== -1) {
      const reader = new FileReader()
      reader.onload = () => {
        try {
          const json = JSON.parse(reader.result as string)
          this.$message.error(json.msg || '导出失败，请稍后重试')
        } catch (e) {
          this.$message.error('导出失败，请稍后重试')
        }
      }
      reader.readAsText(blob)
      return
    }
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.href = url
    a.download = filename
    a.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }

  // 营业数据导出（按店铺区分）
  handleExport() {
    const sid = this.currentStoreId
    const tip = sid
      ? '是否确认导出当前商户最近30天营业数据？'
      : '是否确认导出全部商户最近30天营业数据？将按店铺分表，各店数据互不混淆。'
    this.$confirm(tip, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(async () => {
        const res = await exportInfor(sid || undefined)
        await this.downloadBlob(
          res,
          sid ? '运营数据统计报表-当前商户.xlsx' : '运营数据统计报表-分店.xlsx'
        )
      })
      .catch(() => {})
  }

  // 订单数据导出：近一个月订单 + 营业额/完成数/取消数
  handleOrderExport() {
    const sid = this.currentStoreId
    const tip = sid
      ? '是否确认导出当前商户最近一个月订单数据？将汇总营业额、完成数、取消数量。'
      : '是否确认导出全部商户最近一个月订单数据？将按店铺分表，并汇总营业额、完成数、取消数量。'
    this.$confirm(tip, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(async () => {
        const res = await exportOrderInfor(sid || undefined)
        await this.downloadBlob(
          res,
          sid ? '订单数据报表-当前商户.xlsx' : '订单数据报表-分店.xlsx'
        )
      })
      .catch(() => {})
  }
}
